import fs from "fs";
import { IStorage } from "./IStorage";

export class IStorageJsonFile extends IStorage
{
    private data: any;
    private base_path: string;
    constructor(base_path: string)
    {
        super();
        this.base_path = base_path;
    }
    static data: { [name: string]: string } = {};
    private load(): void
    {
        try
        {
            let content = fs.readFileSync(this.base_path, { encoding: "utf8" });
            this.data = JSON.parse(content);
        } catch (error)
        {
            this.data = {};
        }
    }
    private save(): void
    {
        fs.writeFileSync(this.base_path, JSON.stringify(this.data));
    }
    override get(name: string, defaultValue: string)
    {
        this.load();
        return this.data[name] ?? defaultValue;
    }
    override set(name: string, value: string)
    {
        this.load();
        this.data[name] = value;
        this.save();
    }
    override del(name: string)
    {
        this.load();
        delete this.data[name];
        this.save();
    }
}